import { FormTemplate } from "../../../../types/forms";
import ContactSection from "../../../../components/consultantformsections/ContactSection";
import MedicalSection from "../../../../components/consultantformsections/MedicalSection";
import QuestionSection from "../../../../components/consultantformsections/QuestionSection";
import PolicySection from "../../../../components/consultantformsections/PolicySection";
import DisclaimerSection from "../../../../components/consultantformsections/DisclaimerSection";
import { userId } from "../../../../config";
import SectionPreviewTag from "./SectionPreviewTag";
import SignatureBox from "../../../../components/consultantformsections/ClientSignature";
import MarketingDetailsSection from "../../../../components/consultantformsections/MarketingDetailsSection";
import HeadingSection from "../../../../components/consultantformsections/Heading-Section";
import TextBlockSection from "../../../../components/consultantformsections/TextBlockSection";

interface LivePreviewProps {
  template: FormTemplate;
  currentSection: number;
  totalSections?: number;
}

export default function LivePreview({
  template,
}: LivePreviewProps) {
  return (
    <div className="w-full">
      <div className="bg-white p-6 space-y-6">
        <div className="border-b border-gray-100 pb-4 text-center">
          <h1 className="text-xl font-semibold text-gray-900 mb-1">
            {template.title || "Untitled Form"}
          </h1>
          <p className="text-gray-600 text-sm">
            {template.description ||
              "Provide a brief description for your form."}
          </p>
        </div>

        {template.sections?.length ? (
          template.sections
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .map((section, index) => (
              <div>
                <div >
                  <SectionPreviewTag
                    index={index}
                    total={template.sections.length}
                    title={section.title || "Untitled Section"}
                  />
                </div>
                <div
                  key={section.id || Math.random()}
                  className="border border-gray-100 rounded-sm p-4 shadow-sm hover:shadow transition"

                >

                  <div className="pt-0">
                    {section.type === "contact" && (
                      <ContactSection
                        userId={userId}
                        templateId={template.id}
                        isEditable={true}
                        fields={section.fields}
                      />
                    )}
                    {section.type === "medical" && (
                      <MedicalSection
                        userId={userId}
                        templateId={template.id}
                        isEditable={true}
                        fields={section.fields}
                      />
                    )}
                    {section.type === "question" && (
                      <QuestionSection
                        userId={userId}
                        templateId={template.id}
                        isEditable={true}
                        fields={section.fields}
                      />
                    )}
                    {section.type === "policy" && (
                      <PolicySection
                        userId={userId}
                        templateId={template.id}
                        isEditable={true}
                        fields={section.fields}
                      />
                    )}
                    {section.type === "disclaimer" && (
                      <DisclaimerSection
                        userId={userId}
                        templateId={template.id}
                        isEditable={true}
                        fields={section.fields}
                      />
                    )}
                    {section.type === "marketing" && (
                      <MarketingDetailsSection
                        userId={userId}
                        templateId={template.id}
                        fields={section.fields}
                      />
                    )}
                    {section.type === "heading" && (
                      <HeadingSection
                        userId={userId}
                        templateId={template.id}
                        fields={section.fields}
                      />
                    )}
                    {section.type === "text" && (
                      <TextBlockSection
                        userId={userId}
                        templateId={template.id}
                        fields={section.fields}
                        isEditable={true}
                      />
                    )}
                  </div>
                </div>
              </div>

            ))
        ) : (
          <div className="text-center py-10 text-gray-500 italic">
            No sections added yet.
          </div>
        )}

        {/* Signature Section Preview */}
        <div className="bg-white border border-gray-100 rounded-2xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border-l-2 border-l-[#885ABB]">
          <SignatureBox />
          <p className="text-[10px] text-gray-300 mt-2 text-center italic">Signature field preview</p>
        </div>
      </div>
    </div>
  );
};
